<template>
  <div class="mt-3">
    <PaginatorComponent
      :rows="effectiveRows"
      :totalRecords="totalRecords"
      :first="(currentPage - 1) * rows"
      @page="onPageChange($event)"
	  :showCurrentPageReport="true"
      template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
	  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      class="justify-between px-3"
    />
  </div>
</template>

<script setup lang="ts">


const currentDataFilter = ref('') // ose nga props, ose store

const effectiveRows = computed(() => {
	return currentDataFilter.value ? 1 : props.rows
})


const props = withDefaults( defineProps<{
	totalRecords: number
	rows: number
	currentPage: number
	hidePagination?: boolean;

}>(), {
	hidePagination: false,
} )


const emit = defineEmits(['update:currentPage'])

function onPageChange ( event: any ) {
	const scrollY = window.scrollY
	event?.originalEvent?.preventDefault?.()
	emit( 'update:currentPage', event.page + 1 )
	nextTick( () => {
		setTimeout( () => {
			window.scrollTo( { top: scrollY, behavior: 'instant' } )
		}, 10 )
	} )
}
</script>
<style>
	.p-paginator button:focus {
		outline: none !important;
		box-shadow: none !important;
	}

	.p-paginator:focus-within {
		scroll-margin: 0 !important;
	}

	.p-paginator {
		background: transparent !important;
		padding: 0;
	}

	.p-paginator .p-paginator-current {
		margin-right: auto !important;
	}

	.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
		background: #c6dcf9 !important;
		border-color: #c6dcf9 !important;
		color: #1D4ED8 !important;
	}
</style>
